import { Component, OnInit, Input, OnDestroy, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToastService } from 'core/services';
import { NgClass, NgIf } from '@angular/common';

@Component({
  selector: 'lms-modal-splat',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './modal-splat.component.html',
  imports: [NgIf, NgClass],

  styleUrls: ['./modal-splat.component.scss']
})
export class ModalSplatComponent implements OnInit, OnDestroy {
  @Input() options: any = {};
  @Input() size: any = null;
  @Input() centered: boolean = false;
  @Input() className: string | null = null;
  public isOpen = false;

  public noticeOptions: any = {};
  private noticeSubscription: Subscription;

  constructor(public toastService: ToastService) {}

  public ngOnInit() {
    this.noticeSubscription = this.toastService.notice.subscribe((options: any) => {
      this.noticeOptions = options && options.context === this.toastService.MODAL_CONTEXT ? options : null;
    });
  }

  ngOnDestroy(): void {
    this.noticeSubscription.unsubscribe();
  }

  public open() {
    this.isOpen = true;
    this.setStyle('initial');
  }

  public close() {
    this.isOpen = false;
    this.setStyle('');
  }

  public isClosed() {
    return !this.isOpen;
  }

  /**
   * Configuration of the overlay style
   * @private
   */
  private setStyle(param: string | number): void {
    const activeTabContainer = document.getElementsByClassName('mat-mdc-tab-body-active')[0];
    if (activeTabContainer) {
      activeTabContainer['style']['zIndex'] = param;
    }
  }
}
